import React from 'react';
import './LastUpdated.css';

/**
 * LastUpdated Component
 * Displays the last updated date for help articles and API docs
 * Used across Help Center and API Documentation pages
 */
const LastUpdated = ({ date = '1 day ago' }) => {
  return (
    <div className="last-updated">
      Last updated {date}
    </div>
  );
};

export default LastUpdated;
